import { IRapportInfo } from '../../../../../Types/RapportInfoType';
// import { rapportInfos } from '../RapportInfo';

const PURapportMeny: IRapportInfo[] = [];

export default PURapportMeny;
